<template>
<div>
    <v-layout wrap >
        <v-flex xs12 style="text-align: center">
            <h2>
                Order Summary
            </h2>
        </v-flex>
        <v-flex xs12 sm12 md6 lg4>
            <v-card ref="personalInfo" flat :style="{'borderRadius': '0px', 'border-right': '1px solid lightgrey', 'height': cardHeight}">
                <v-card-title>
                    Personal Information
                </v-card-title>
                <v-card-text>
                    <v-list>
                        <v-list-tile>
                            <v-list-tile-action>
                                <v-icon>location_on</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content style="white-space: normal">
                                <v-list-tile-title style="white-space: normal" v-if="detail.address&&detail.address.locationDescription">
                                    {{detail.address.locationDescription}}
                                </v-list-tile-title>
                                <v-list-tile-title style="white-space: normal" v-else-if="detail.address">
                                    {{detail.address.locationDescription}}
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile three-line>
                            <v-list-tile-action align="center">
                                <v-icon>account_circle</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    {{detail.primaryContact.firstName}} {{detail.primaryContact.lastName}}
                                </v-list-tile-title>
                                <v-list-tile-subtitle>
                                    Primary Contact
                                </v-list-tile-subtitle>
                                 <v-list-tile-subtitle>
                                     {{detail.primaryContact.emailAddress}} | {{detail.primaryContact.contactNumber}}
                                              
                                 </v-list-tile-subtitle>

                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile v-if="detail.secondaryContact">
                            <v-list-tile-action>
                                <v-icon v-if="detail.secondaryContact" color="light-green">check_circle_outline</v-icon>
                                <v-icon v-else color="red">cancel</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title v-if="detail.secondaryContact">
                                    {{detail.secondaryContact.firstName}} {{detail.secondaryContact.lastName}}
                                </v-list-tile-title>
                                <v-list-tile-subtitle>
                                    Secondary Contact
                                </v-list-tile-subtitle>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile v-if="detail.billingContact">
                            <v-list-tile-action>
                                <v-icon v-if="detail.billingContact" color="light-green">check_circle_outline</v-icon>
                                <v-icon v-else color="red">cancel</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title v-if="detail.billingContact">
                                    {{detail.billingContact.firstName}} {{detail.billingContact.lastName}}
                                </v-list-tile-title>
                                <v-list-tile-subtitle>
                                    Billing Contact
                                </v-list-tile-subtitle>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-card-text>
            </v-card>
        </v-flex>

        <v-flex xs12 sm12 md6 lg4>
            <v-card ref="packageInfo" flat :style="{'borderRadius': '0px', 'border-right': '1px solid lightgrey', 'height': cardHeight}">
                <v-card-title>
                    Purchase Details
                </v-card-title>
                <v-card-text>
                    <v-list>
                        <!-- <v-list-header>
                            <b><u>Once off Costs:</u></b>
                        </v-list-header> -->
                        <v-list-tile>
                            <v-list-tile-avatar style="max-height: 100px; width: 80px">
                                <v-img :src="
                                $store.state.currentOrg.orderPageLogo
                                  ? $store.state.currentOrg.orderPageLogo
                                  : $store.state.currentOrg.logo
                              " contain></v-img>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                                <v-list-tile-title style="white-space: normal">
                                    Installation fees
                                </v-list-tile-title>
                                <!-- <v-list-tile-subtitle>
                                    Once off fee
                                </v-list-tile-subtitle> -->
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <b>{{installationfee | currency}}</b>

                            </v-list-tile-action>
                        </v-list-tile>
                        <v-list-tile v-for="product in productArray" :key="product.id">
                            <v-list-tile-avatar style="max-height: 100px; width: 80px">
                                <v-img :src="
                                $store.state.currentOrg.orderPageLogo
                                  ? $store.state.currentOrg.orderPageLogo
                                  : $store.state.currentOrg.logo
                              " aspect-ratio="1.4" contain></v-img>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                                <v-list-tile-title style="white-space: normal">
                                    <span v-if="product.stockItem">{{product.stockItem.name}}</span>
                                    <span v-else-if="product.deviceMakeModel">{{product.deviceMakeModel.name}}</span>
                                </v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <b v-if="product.stockItem">{{(product.stockItem.priceExclVat)*(1+$VAT) | currency}}</b>
                                <b v-else-if="product.deviceMakeModel"> {{product.deviceMakeModel.priceInclVat | currency}}</b>
                            </v-list-tile-action>
                        </v-list-tile>

                        <v-list-tile v-if="detail.selectedInternetPackage&&detail.selectedInternetPackage.onceOffPriceVatInc">
                            <v-list-tile-action 
                                 style="max-height: 100px; width: 80px"
                            >
                                <v-img :src="
                                detail.selectedInternetPackage.customerOrganisation.logo
                              " aspect-ratio="1.4" contain></v-img>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title style="white-space: normal">
                                    {{detail.selectedInternetPackage.name}}
                                </v-list-tile-title>
                                <v-list-tile-subtitle>
                                    Once off fee
                                </v-list-tile-subtitle>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <b>{{detail.selectedInternetPackage.onceOffPriceVatInc | currency}}</b>
                            </v-list-tile-action>
                        </v-list-tile>
                        <v-list-tile style="border-top: 1px solid black;border-bottom: 1px solid black">
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    <b>Total Once off Costs:</b>
                                </v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <b>{{totalOnceOffCost | currency}}</b>
                            </v-list-tile-action>
                        </v-list-tile>
                        <!-- <v-list-header>
                            <b><u>Monthly Costs:</u></b>
                        </v-list-header> -->
                        <v-list-tile v-if="detail.selectedInternetPackage">
                            <v-list-tile-action style="max-height: 100px; width: 80px">
                                <v-img v-if="detail.selectedInternetPackage" :src="
                                detail.selectedInternetPackage.customerOrganisation.logo
                              " aspect-ratio="1.4" contain></v-img>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title style="white-space: normal">
                                    {{detail.selectedInternetPackage.name}}
                                </v-list-tile-title>
                                <v-list-tile-subtitle>
                                    Monthly Fee
                                </v-list-tile-subtitle>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <b>{{detail.selectedInternetPackage.recurringPriceVatInc | currency}}</b>
                            </v-list-tile-action>
                        </v-list-tile>
                        <v-list-tile v-if="detail.selectedInternetPackage" style="border-top: 1px solid black;border-bottom: 1px solid black">
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    <b>Total Recurring Costs:</b>
                                </v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <b>{{detail.selectedInternetPackage.recurringPriceVatInc | currency}} pm</b>
                            </v-list-tile-action>
                        </v-list-tile>
                    </v-list>

                </v-card-text>
            </v-card>
        </v-flex>
        <v-flex xs12 sm12 md6 lg4>
            <v-card ref="terms" flat :style="{'borderRadius': '0px', 'border-right': '1px solid lightgrey', 'height': cardHeight}">
                <v-card-text style="padding:0; margin:0; fontSize: 12px">
                    <v-list style="padding:0; margin:0">
                        <v-card-title style="padding-bottom: 0px; margin-bottom: 0px">
                            Preferred Activation Date
                        </v-card-title>
                        <v-list-tile three-line>
                            <v-list-tile-content style="white-space: normal; color: grey; fontSize: 12px">
We will do our best to accommodate you, however this date is subject to availability.
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-dialog ref="dialog" v-model="modal" :return-value.sync="detail.activationDate" persistent width="290px">
                                    <template v-slot:activator="{ on, attrs }" style="width: 150px">
                                        <v-text-field readonly style="width: 150px; fontSize: 14px" outlined rounded v-model="detail.activationDate" append-icon="mdi-calendar" v-bind="attrs" v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="detail.activationDate" scrollable :min="detail.minActivationDate" :allowed-dates="allowedDates">
                                        <v-spacer></v-spacer>
                                        <v-btn text @click="modal = false">
                                            Cancel
                                        </v-btn>
                                        <v-btn text @click="$refs.dialog.save(detail.activationDate)">
                                            OK
                                        </v-btn>
                                    </v-date-picker>
                                </v-dialog>
                            </v-list-tile-action>
                        </v-list-tile>
                        <!-- <v-list-tile-title>
                            <b>Terms & Conditions</b>
                        </v-list-tile-title> -->
                        <v-card-title style="padding-top: 0px; margin-top: 0px">
                            Terms & Conditions
                        </v-card-title>
                        <v-list-tile style="padding:0; margin:0">
                            <v-list-tile-action>
                                <v-checkbox color="primary" v-model="fnoTermsAccepted">
                                </v-checkbox>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-subtitle style="white-space: normal; fontSize: 12px">
                                    I agree to the {{$store.state.currentOrg.name}}
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <a v-if="fnoTerms" text style="color: grey" @click="viewFnoTerms = true">
                                                Terms and Conditions
                                            </a>
                                            <a v-else target="_blank" style="color: grey" :href="$store.state.currentOrg.termsAndConditionsLink" @click.stop v-on="on">
                                                Terms and Conditions
                                            </a>
                                        </template>
                                        Opens link to T&C's in new window
                                    </v-tooltip>
                                </v-list-tile-subtitle>
                            </v-list-tile-content>
                            <!-- <v-icon style="padding: 10px">launch</v-icon> -->
                        </v-list-tile>
                        <!-- <v-list-tile v-if="detail.selectedInternetPackage" style="padding:0; margin:0">
                            <v-list-tile-action>
                                <v-checkbox color="primary" v-model="ispTermsAccepted">
                                </v-checkbox>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-subtitle style="white-space: normal; fontSize: 12px">
                                    I agree to the {{detail.selectedInternetPackage.customerOrganisation.name}} <a target="_blank" style="color: grey" :href="
                                            detail.selectedInternetPackage.customerOrganisation.termsAndConditionsLink
                                          ">
                                        Terms and Conditions
                                    </a>
                                </v-list-tile-subtitle>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile v-if="detail.selectedInternetPackage" style="padding:0; margin:0">
                            <v-list-tile-action>
                                <v-checkbox color="primary" v-model="agreeSharing">
                                </v-checkbox>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-subtitle style="white-space: normal; fontSize: 12px">
                                    I agree to {{$store.state.currentOrg.name}} sharing my contact details with {{detail.selectedInternetPackage.customerOrganisation.name}}
                                </v-list-tile-subtitle>
                            </v-list-tile-content>
                        </v-list-tile> -->
                        <v-text-field
                        rounded outlined
                        dense
                            class="px-3"
                            v-model="detail.promoCode"
                            placeholder="Promotion Code"
                          >
                          </v-text-field>
                        <v-textarea dense class="px-3" auto-grow rows="1" rounded outlined placeholder="Anything extra you would like us to know :)" v-model="detail.notes"></v-textarea>

                    </v-list>
                </v-card-text>
            </v-card>
        </v-flex>
        <v-flex xs12>
            <v-layout wrap  style="margin-left: 20px; margin-right: 20px">
                <v-btn rounded color="primary" @click="back()">
                    <v-icon>chevron_left</v-icon> Back
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn rounded color="primary" :disabled="!ValidateTerms()" @click="submit()"> Submit <v-icon>chevron_right</v-icon>
                </v-btn>
            </v-layout>
        </v-flex>
    </v-layout>
</div>
</template>

<script>
var disabledDates = [
    "2021-12-09",
    "2021-12-10",
    "2021-12-11",
    "2021-12-12",
    "2021-12-13",
    "2021-12-14",
    "2021-12-15",
    "2021-12-16",
    "2021-12-17",
    "2021-12-18",
    "2021-12-19",
    "2021-12-20",
    "2021-12-21",
    "2021-12-22",
    "2021-12-23",
    "2021-12-24",
    "2021-12-25",
    "2021-12-26",
    "2021-12-27",
    "2021-12-28",
    "2021-12-29",
    "2021-12-30",
    "2021-12-31",
    "2022-01-01",
    "2022-01-02",
    "2022-01-03",
    "2022-01-04",
    "2022-01-05",
    "2022-01-06",
    "2022-01-07",
    "2022-01-08",
    "2022-01-09"
];
export default {
    props: ['detail', 'network', 'productArray'],
    data() {
        return {
            agreeSharing: false,
            cardHeight: '480px',
            fnoTermsAccepted: false,
            fnoTerms: null,
            ispTermsAccepted: false,
            modal: false,
            viewFnoTerms: false
        }
    },
    watch: {
        detail(value){
         console.log(this.cardHeight)

        }
    },
    created() {
         if(!this.$vuetify.breakpoint.xs){
         this.cardHeight = this.$refs.terms.$el.clientHeight+'px'
        } else {
            this.cardHeight='auto'
        }
    },
    activated(){
        if(!this.$vuetify.breakpoint.xs){
         this.cardHeight = this.$refs.terms.$el.clientHeight+'px'
        } else {
            this.cardHeight='auto'
        }

    },
    computed: {
        formattedAddress() {
            let address = ''
            if (this.detail.address.unitNumber) {
                address += 'Unit ' + this.address.unitNumber + ', '
            }
            if (this.detail.address.floorNo) {
                address += 'floor ' + this.address.floorNo + ', '
            }
            if (this.detail.address.building) {
                address += this.address.detail.building + ', '
            }
            if (this.detail.address.streetNumber) {
                address += this.address.detail.streetNumber + ' '
            }
            if (this.detail.address.streetName) {
                address += this.address.detail.streetName + ', '
            }
            if (this.detail.address.suburb) {
                address += this.address.detail.suburb + ', '
            }
            if (this.detail.address.town) {
                address += this.address.detail.town + ', '
            }
            if (this.detail.address.province) {
                address += this.address.detail.province + ', '
            }
            if (this.detail.address.country) {
                address += this.address.detail.country + '  '
            }
            if (this.detail.address.postalCode) {
                address += this.address.detail.postalCode
            }
            return address
        },
        installationfee() {
            let result = 0
            if (this.network && this.network.routerInstallationFee) {
                if (this.detail.selectedInternetPackage != null &&
                    this.detail.selectedInternetPackage.packagesFno.packagesFnoCat.packageCatType ===
                    'Residential') {
                    result = this.network.residentialRouterInstallationFeeAmount
                    /*
                    if(this.detail.selectedInternetPackage.onceOffPriceVatInc) {
                        result = this.detail.selectedInternetPackage.onceOffPriceVatInc
                    } else {
                        result = this.network.residentialRouterInstallationFeeAmount
                    }
                    */
                    console.log(result)
                } else if (this.detail.selectedInternetPackage &&
                    this.detail.selectedInternetPackage.packagesFno.packagesFnoCat.packageCatType ===
                    'Business') {
                    result = this.network.businessRouterInstallationFeeAmount
                }
            }
            return result
        },
        totalOnceOffCost() {
            let result = 0
            result += this.installationfee
            for (let i = 0; i < this.productArray.length; i++) {
                if (this.productArray[i].stockItem) {
                    result += (this.productArray[i].stockItem.priceExclVat) * (1 + this.$VAT)
                } else if (this.productArray[i].deviceMakeModel) {
                    result += this.productArray[i].deviceMakeModel.priceInclVat
                }
            }
            return result
        }
    },
    methods: {
        allowedDates: (val) => new Date(val).getDay() < 6 && new Date(val).getDay() > 0 && !disabledDates.includes(val),
        addDays(date, days) {
            var result = new Date(date);
            result.setDate(result.getDate() + days);
            result.toISOString();
            return result;
        },
        back() {
            this.$emit('back')
        },
        submit() {
            this.$emit('submit')
        },
        ValidateTerms() {
            let result = this.fnoTermsAccepted
            return result
        }

    }
}
</script>
